var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',{on:{"start":function($event){_vm.drag = true},"end":function($event){_vm.drag = false},"change":_vm.change},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}},[_c('transition-group',_vm._l((_vm.items),function(item){return _c(_vm.componentName,{key:item.id,tag:"component",attrs:{"value":item},on:{"edit":function (val) {
          _vm.editDocumentBlock(val, item.order);
        },"delete":function($event){return _vm.$emit('delete', item.id)},"add":function (val) {
          _vm.addDocumentBlock(val, item.order);
        },"apply":function (versionId) {
          _vm.$emit('apply', { versionId: versionId, id: item.id });
        },"decline":function (versionId) {
          _vm.$emit('decline', { versionId: versionId, item: item });
        }}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }